import { Button, Icon, Text } from '@goodfynd/ui';

import { styled } from '../../../theme/stitches.config';
import NextEventInfo from '../../NextEventInfo';

export const StyledBlock = styled('aside', {
  '+ aside': {
    marginTop: 16,
    '@lg': {
      marginTop: 0,
    },
  },
});

export const StyledButton = styled(Button, {
  display: 'inline',
  borderRadius: 4,
  boxShadow: 'none',
  '+ button': {
    marginLeft: 12,
  },
});

export const StyledContainer = styled('section', {
  gap: 16,
  justifyContent: 'space-between',
  marginTop: 16,
  '@sm': {
    padding: '0 16px',
  },
  '@lg': {
    display: 'flex',
  },
});

export const StyledIconLabel = styled(Icon, {
  alignItems: 'flex-start !important',
  marginTop: 24,
  [`+ ${Icon}`]: {
    marginTop: 16,
  },
});

export const StyledNextEventInfo = styled(NextEventInfo, {
  marginTop: 48,
});

export const StyledName = styled(Text, {
  fontSizeRem: 26,
  fontWeight: 800,
  lineHeightRem: 32,
  margin: 0,
  '@lg': {
    fontSizeRem: 36,
    lineHeightRem: 48,
  },
});

export const StyledNoEventsContainer = styled('section', {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  marginTop: 50,
});

export const StyledQuickInfo = styled('div', {
  alignItems: 'center',
  display: 'flex',
});
